(() => {
  class Recommendations extends HTMLElement {
    connectedCallback() {
      if (this.loaded) return;
      this.loaded = true;
      if (this.querySelector('.product-card')) return;
      this.hidden = false;
      this.style.minHeight = '1px';
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => { if (entries[0].isIntersecting) { this.observer.disconnect(); this.load(); } }, {rootMargin:'200px'});
        this.observer.observe(this);
      } else this.load();
    }
    async load() {
      this.controller = new AbortController();
      const timer = setTimeout(() => this.controller.abort(), 8000);
      try {
        const response = await fetch(this.dataset.url, {signal:this.controller.signal, credentials:'same-origin'});
        if (!response.ok) throw Error('Recommendations unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const content = doc.querySelector('ha-recommendations');
        if (!content?.querySelector('.product-card')) { this.hidden = true; return; }
        this.replaceChildren(...content.childNodes);
        this.style.minHeight = '';
        this.dispatchEvent(new CustomEvent('helloamino:content:loaded', {bubbles:true}));
      } catch { this.hidden = true; }
      finally { clearTimeout(timer); }
    }
    disconnectedCallback() { this.observer?.disconnect(); this.controller?.abort(); }
  }
  if (!customElements.get('ha-recommendations')) customElements.define('ha-recommendations', Recommendations);
})();

